import { type Static, Type } from '@sinclair/typebox';
import { MongoIdStringSchema, PaginateDTOSchema } from '../dto/common.dto.js';
import { PodcastDTOSchema } from '../dto/podcast.dto.js';
import { PodcastEpisodeDTOSchema } from '../dto/podcast-episode.dto.js';

// ---------------------------------------------------------------------------------------------------------------------

export const RetrievePodcastQuerystringSchema = Type.Object({
  channelId: Type.Optional(Type.String()),
  feedUrl: Type.Optional(Type.String()),
  itunesTrackId: Type.Optional(Type.Number()),
  slug: Type.Optional(Type.String()),
});
export type RetrievePodcastQuerystring = Static<typeof RetrievePodcastQuerystringSchema>;

export const RetrievePodcastReplySchema = PodcastDTOSchema;
export type RetrievePodcastReply = Static<typeof RetrievePodcastReplySchema>;

// ---------------------------------------------------------------------------------------------------------------------

export const RetrievePodcastEpisodeQuerystringSchema = Type.Union([
  Type.Object({
    slug: Type.String(),
    channelSlug: Type.String(),
  }),
  Type.Object({
    itemId: Type.String(),
  }),
]);
export type RetrievePodcastEpisodeQuerystring = Static<typeof RetrievePodcastEpisodeQuerystringSchema>;

export const RetrievePodcastEpisodeReplySchema = PodcastEpisodeDTOSchema;
export type RetrievePodcastEpisodeReply = Static<typeof RetrievePodcastEpisodeReplySchema>;

// ---------------------------------------------------------------------------------------------------------------------

export const ListPodcastEpisodesQuerystringSchema = Type.Object({
  channelId: MongoIdStringSchema,
  page: Type.Number(),
});
export type ListPodcastEpisodesQuerystring = Static<typeof ListPodcastEpisodesQuerystringSchema>;

export const ListPodcastEpisodesReplySchema = PaginateDTOSchema(PodcastEpisodeDTOSchema);
export type ListPodcastEpisodesReply = Static<typeof ListPodcastEpisodesReplySchema>;

// ---------------------------------------------------------------------------------------------------------------------

export const ListPodcastsBodySchema = Type.Object({ channels: Type.Array(Type.String()) });
export type ListPodcastsBody = Static<typeof ListPodcastsBodySchema>;

export const ListPodcastsReplySchema = Type.Array(PodcastDTOSchema);
export type ListPodcastsReply = Static<typeof ListPodcastsReplySchema>;

// ---------------------------------------------------------------------------------------------------------------------

export const RetrievePodcastSlugByIdParamsSchema = Type.Object({ id: Type.String() });
export type RetrievePodcastSlugByIdParams = Static<typeof RetrievePodcastSlugByIdParamsSchema>;

export const RetrievePodcastSlugByIdReplySchema = Type.Object({ slug: Type.String() });
export type RetrievePodcastSlugByIdReply = Static<typeof RetrievePodcastSlugByIdReplySchema>;

// =====================================================================================================================
// Stream Podcast
// =====================================================================================================================

export const StreamPodcastQueryStringSchema = Type.Object({ itemId: Type.String() });
export type StreamPodcastQueryString = Static<typeof StreamPodcastQueryStringSchema>;

// =====================================================================================================================
// List Top Podcasts
// =====================================================================================================================

export const ListTopPodcastsQueryStringSchema = Type.Object({
  genre: Type.Optional(PodcastDTOSchema.properties.categories.items),
  limit: Type.Optional(Type.Number({ minimum: 1, maximum: 25 })),
});
export type ListTopPodcastsQueryString = Static<typeof ListTopPodcastsQueryStringSchema>;

export const ListTopPodcastsReplySchema = Type.Array(PodcastDTOSchema);
export type ListTopPodcastsReply = Static<typeof ListTopPodcastsReplySchema>;
